import React, { useMemo } from 'react';
import katex from 'katex';
import { NodeViewWrapper } from '@tiptap/react';

const renderEquation = (latex, display) => {
  try {
    return {
      html: katex.renderToString(latex, {
        displayMode: display === 'block',
        throwOnError: true,
        trust: false,
        strict: 'error',
        maxSize: 10,
        maxExpand: 100,
        output: 'htmlAndMathml',
      }),
      error: '',
    };
  } catch (error) {
    return {
      html: '',
      error: `LaTeX : ${error?.message || 'équation invalide'}`,
    };
  }
};

const BookEquationView = ({
  node,
  extension,
  selected,
  getPos,
  deleteNode,
}) => {
  const { latex, display } = node.attrs;
  const preview = useMemo(
    () => renderEquation(latex, display),
    [latex, display]
  );
  const Wrapper = display === 'block' ? 'div' : 'span';

  return (
    <NodeViewWrapper
      as={Wrapper}
      className={[
        'book-equation',
        `book-equation--${display}`,
        selected ? 'book-equation--selected' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      contentEditable={false}
      data-drag-handle
    >
      {preview.error ? (
        <span className="book-equation-error" role="alert">
          {preview.error}
        </span>
      ) : (
        <span
          className="book-equation-render"
          dangerouslySetInnerHTML={{ __html: preview.html }}
        />
      )}
      <span className="book-equation-actions">
        <button
          type="button"
          aria-label="Modifier l’équation"
          onClick={(event) => {
            event.stopPropagation();
            const pos = getPos();
            if (Number.isInteger(pos)) {
              extension.options.onEditEquation?.({ pos, latex, display });
            }
          }}
        >
          Modifier
        </button>
        <button
          type="button"
          aria-label="Supprimer l’équation"
          onClick={(event) => {
            event.stopPropagation();
            deleteNode();
          }}
        >
          Supprimer
        </button>
      </span>
    </NodeViewWrapper>
  );
};

export default BookEquationView;
